import { ChatContext, ChatContextType } from 'context/chat/chat.context';
import { useContext } from 'react';

export const useChat = (): ChatContextType => {
  return useContext(ChatContext);
};
